<template>
  <div>
    <div style="
        width: 100vw;
        height: 100vh;
        background-image: url('/img/webbg.png');
        background-size: cover;
        background-position: center;
        background-repeat: no-repeat;
        overflow: hidden;
        "
        
        v-loading="sendFlag"
      element-loading-text="数据发送中，请稍后"
      element-loading-spinner="el-icon-loading"
      element-loading-background="rgba(0, 0, 0, 0.8)"

      @click.stop @mousedown.stop.prevent

>
      <!-- <div class="container"> -->

      <!-- <div style="position: absolute;
			left: 35%;
			width: 8rem; 
			height: 8rem;
      top: 80vh;
      z-index: 992;">
        <img src="../assets/img/hld_fl03.png" style="
			width: 6.2rem; 
			height: 6.2rem;
			" @contextmenu.prevent="preventContextMenu">

      </div> -->
      <div class="gitContainer" v-if="showGif"   @contextmenu.prevent="preventContextMenu" > 
        <img src="../assets/img/1.gif" style="width: 100%;" alt="GIF"  @contextmenu.prevent="preventContextMenu"  class="disable-click" />
        <div style="font-size: 2.1vh;
        color:#E4E7ED;
        font-family: 'Microsoft YaHei', sans-serif;"
         @contextmenu.prevent="preventContextMenu" 
        >说话中...</div>
      </div>

      <div  style="background-image: url('/img/yx_fl06b.png');
        background-position: center;
        background-repeat: no-repeat;
          width: 10vh;height: 10vh;
          margin: 0 auto;
          margin-top: 80vh; "  
          v-if="pageFlag"
      
      @touchstart.prevent="handleTouchStart($event)" @touchend.prevent="iatStop"
      >


          <!-- <img src="../assets/img/yx/yx_fl06b.png" style="margin-top: 80vh;-webkit-touch-callout: none;"  draggable="false" @touchstart.prevent="handleTouchStart($event)" @touchend.prevent="iatStop"> -->
      </div>

      <!-- <div style="position: absolute;
			top:75vh;
			left:  35vw;
			width: 10rem; 
			height: 10rem;
      border-radius: 50%;
      background-image:url('/img/hld_fl03.png') ;
      background-size: cover;
        background-position: center;
        background-repeat: no-repeat;"
        @contextmenu.prevent="preventContextMenu"
        v-if="pageFlag"
        class="disable-click"

        @click.stop @mousedown.stop.prevent
      > 
        <img src="../assets/img/hld_ic02b.png" style="
			width: 2.5rem; 
			height: 3.8rem ;
      margin-top: 3.2rem;
      margin-left: 1rem;
      z-index: 999;"          class="disable-click"
          @touchstart.prevent="iatStart" @touchend.prevent="iatStop" />
        <img src="../assets/img/hld_ic07.png" style="
			width: 1.2rem; 
			height: 1.2rem; 
      margin-bottom: 3.0rem;
      "
      class="disable-click"
      @contextmenu.prevent="preventContextMenu"
      @touchstart.prevent="preventContextMenu" @touchend.prevent="preventContextMenu" 
      @click.stop @mousedown.stop.prevent
      />
      </div> -->
      <div v-else
      style="width: 100%;height: 100%;"
      v-loading="!pageFlag"
      element-loading-text="页面载入数据有误，请重新扫描二维码"
      element-loading-spinner="el-icon-loading"
      element-loading-background="rgba(0, 0, 0, 0.8)"
      class="disable-click"
      @click.stop @mousedown.stop.prevent
      >

      </div>
    </div>
  </div>
  <!-- </div> -->
</template>
<script>
import { Message } from 'element-ui'; // 导入 Element UI 中的 Message 组件

export default {
  name: "Login",
  data() {
    return {
      specialSymbols: "。？，；‘’“”!@#$%^&*()_+:`~",
      API_SECRET: "NzVmNzA3NjI2ODE4ODdlY2ZhYmRkZjhl",
      API_KEY: "ce9dc9b423e8036f66c252329e3844a2",
      btnStatus: "UNDEFINED", // "UNDEFINED" "CONNECTING" "OPEN" "CLOSING" "CLOSED"
      recorder: null,
      iatWS: null,
      resultInfo: "",
      showGif: false,
      pageFlag:true,
      sendFlag:false,

    };
  },

  mounted() {
      const hashQuery = this.$route.query;
      console.log("hashQueryhashQueryhashQuery",hashQuery)
			if(hashQuery&&hashQuery.type=="H5_SAY"){
        let obj = {
          accessToken:hashQuery.token,
          type:hashQuery.type
        }
        localStorage.setItem("USER_INFO",JSON.stringify(obj))
        this.initRecorder();
			}else{
        Message.error('页面参数有误，请重新扫描二维码进入');
        this.pageFlag = false
			}
      this.initMediaDevives()
  },
  methods: {
    handleTouchStart(event) {
    event.preventDefault(); // 阻止默认行为
    // 调用需要执行的方法
    this.iatStart();
  },
    initMediaDevives(){
      if (navigator.mediaDevices 
      && navigator.mediaDevices.getUserMedia 
      && window.MediaRecorder) {
        navigator.mediaDevices.getUserMedia({ audio: true }).then(function(stream){
          console.log("以获取麦克风权限")
        })
      }else {
        console.error('浏览器不支持获取麦克风权限或 MediaRecorder API');
      }
    },
    sendInfo(){
      if(!this.resultInfo){
        return
      }
      
      let userInfo =  this.$getUserInfo();

      let params={
        key:userInfo.accessToken,
        content:this.resultInfo
      }

      this.sendFlag = true
      this.$axios.post(this.$urls.putSayInfo,params).then((res) => {
          setTimeout(() => {
            this.sendFlag = false// 调用您想要执行的方法
         }, 2000); 
      });
      
    },
    preventContextMenu(event) {
      event.preventDefault(); // 阻止默认的上下文菜单行为
    },
    initRecorder() {
      this.recorder = new RecorderManager("/dist");

      this.recorder.onStart = () => {
        this.changeBtnStatus("OPEN");
      };

      this.recorder.onFrameRecorded = ({ isLastFrame, frameBuffer }) => {
        if (this.iatWS.readyState === this.iatWS.OPEN) {
          this.iatWS.send(
            JSON.stringify({
              data: {
                status: isLastFrame ? 2 : 1,
                format: "audio/L16;rate=16000",
                encoding: "raw",
                audio: this.toBase64(frameBuffer),
              },
            })
          );
          if (isLastFrame) {
            this.changeBtnStatus("CLOSING");
          }
        }
      };
      this.recorder.onStop = () => {
        // clearInterval(countdownInterval);

      };
    },
    iatStart() {
      this.showGif = true;
      this.resultInfo = "";
      if (this.btnStatus === "UNDEFINED" || this.btnStatus === "CLOSED") {
        this.connectWebSocket();
      } else if (this.btnStatus === "CONNECTING" || this.btnStatus === "OPEN") {
        // 结束录音
        this.recorder.stop();
      }
    },
    iatStop() {
      this.showGif = false;
      this.recorder.stop();
      this.changeBtnStatus("CLOSED");
      this.startFlag = false;
    },
    getWebSocketUrl() {
      var url = "wss://iat-api.xfyun.cn/v2/iat";
      var host = "iat-api.xfyun.cn";
      var apiKey = process.env.VUE_APP_IAT_API_KEY;
      var apiSecret = process.env.VUE_APP_IAT_API_SECRET;
      var date = new Date().toGMTString();
      var algorithm = "hmac-sha256";
      var headers = "host date request-line";
      var signatureOrigin = `host: ${host}\ndate: ${date}\nGET /v2/iat HTTP/1.1`;
      var signatureSha = CryptoJS.HmacSHA256(signatureOrigin, apiSecret);
      var signature = CryptoJS.enc.Base64.stringify(signatureSha);
      var authorizationOrigin = `api_key="${apiKey}", algorithm="${algorithm}", headers="${headers}", signature="${signature}"`;
      var authorization = btoa(authorizationOrigin);
      url = `${url}?authorization=${authorization}&date=${date}&host=${host}`;
      return url;
    },
    connectWebSocket() {
      const websocketUrl = this.getWebSocketUrl();
      if ("WebSocket" in window) {
        this.iatWS = new WebSocket(websocketUrl);
      } else if ("MozWebSocket" in window) {
        this.iatWS = new MozWebSocket(websocketUrl);
      } else {
        alert("不支持WebSocket");
        return;
      }
      this.changeBtnStatus("CONNECTING");
      this.iatWS.onopen = (e) => {
        // 开始录音
        this.recorder.start({
          sampleRate: 16000,
          frameSize: 1280,
        });
        var params = {
          common: {
            app_id: process.env.VUE_APP_IAT_APPID,
          },
          business: {
            language: "zh_cn",
            domain: "iat",
            accent: "mandarin",
            vad_eos: 5000,
            // dwa: "wpgs",
          },
          data: {
            status: 0,
            format: "audio/L16;rate=16000",
            encoding: "raw",
          },
        };
        this.iatWS.send(JSON.stringify(params));
      };
      this.iatWS.onmessage = (e) => {
        this.renderResult(e.data);
      };
      this.iatWS.onerror = (e) => {
        console.error(e);
        this.recorder.stop();
        this.changeBtnStatus("CLOSED");
      };
      this.iatWS.onclose = (e) => {
        this.recorder.stop();
        this.changeBtnStatus("CLOSED");
      };
    },
    changeBtnStatus(status) {
      this.btnStatus = status;
      if (status === "CONNECTING") {
        // btnControl.innerText = "建立连接中";
        // document.getElementById("result").innerText = "";
        // resultText = "";
        // resultTextTemp = "";
        console.log("建立链接中");
      } else if (status === "OPEN") {
        this.countdown();
      } else if (status === "CLOSING") {
        // btnControl.innerText = "关闭连接中";
      } else if (status === "CLOSED") {
        console.log("guanbi",this.resultInfo)
        // btnControl.innerText = "开始录音";
      }
    },

    renderResult(resultData) {
      let resultText = "";
      let resultTextTemp = "";
      console.log("resultDataresultData", resultData);
      // 识别结束
      let jsonData = JSON.parse(resultData);
      if (jsonData.data && jsonData.data.result) {
        let data = jsonData.data.result;
        let str = "";
        let ws = data.ws;
        for (let i = 0; i < ws.length; i++) {
          str = str + ws[i].cw[0].w;
        }
        // 开启wpgs会有此字段(前提：在控制台开通动态修正功能)
        // 取值为 "apd"时表示该片结果是追加到前面的最终结果；取值为"rpl" 时表示替换前面的部分结果，替换范围为rg字段
        if (data.pgs) {
          if (data.pgs === "apd") {
            // 将resultTextTemp同步给resultText
            resultText = resultTextTemp;
          }
          // 将结果存储在resultTextTemp中
          resultTextTemp = resultText + str;
        } else {
          resultText = resultText + str;
        }
        if (this.specialSymbols.indexOf(resultTextTemp) < 0 ||
          this.specialSymbols.indexOf(resultText) < 0) {
          this.resultInfo = this.resultInfo+ (resultTextTemp || resultText || "");
        }
      }
      if (jsonData.code === 0 && jsonData.data.status === 2) {
        this.iatWS.close();
        this.sendInfo();
      }
      if (jsonData.code !== 0) {
        this.iatWS.close();
        console.error(jsonData);
      }
    },
    countdown() {
      // let seconds = 60;
      // btnControl.innerText = `录音中（${seconds}s）`;
      // countdownInterval = setInterval(() => {
      //   seconds = seconds - 1;
      //   if (seconds <= 0) {
      //     clearInterval(countdownInterval);
      //     recorder.stop();
      //   } else {
      //     btnControl.innerText = `录音中（${seconds}s）`;
      //   }
      // }, 1000);
    },
    toBase64(buffer) {
      var binary = "";
      var bytes = new Uint8Array(buffer);
      var len = bytes.byteLength;
      for (var i = 0; i < len; i++) {
        binary += String.fromCharCode(bytes[i]);
      }
      return window.btoa(binary);
    },
  },
};
</script>
<style scoped>
.gitContainer {
  position: absolute;
  top: 60%;
  left: 43%;
  transform: translate(0%, -200%);
  z-index: 9999;
  /* background-image: url("../assets/img/1.gif"); */
  /* 替换为你的 GIF 图片路径 */
  background-size: cover;
  display: block;
  margin: 0 auto;
}
.disable-click {
  pointer-events: none;
}
</style>